module.exports = __webpack_public_path__ + "static/media/activity-create-your-avatar.2dc6bfdb.png";